import { FIXTURE_DATA_ENABLED } from '../shared/fixtures/flag';

/**
 * Says, on every screen and permanently, that the information shown is invented.
 *
 *   demo-data, "A viewer can always tell they are looking at invented data"
 *     #### Scenario: The marker is on every screen
 *     #### Scenario: The marker cannot be turned off from inside
 *
 * **This is not decoration.** This build is going to be shown to people, and a
 * client screen full of invented body measurements is exactly the artefact that
 * gets screenshotted and later mistaken for a real person's data. The marker is
 * what makes that mistake impossible to make honestly.
 *
 * So it is built to be impossible to remove from inside the product:
 *
 *   * there is **no dismiss control** — nothing to click, so nothing to click by
 *     accident and nothing a demonstration can tidy away before a screenshot;
 *   * it is fixed to the top of the viewport, above everything, so it cannot be
 *     scrolled past or hidden behind a sheet;
 *   * it is in the normal document flow's way rather than floating over the
 *     content, so it cannot be cropped out of a full-page capture without the
 *     crop being obvious;
 *   * it renders nothing at all when the flag is off, which is every build
 *     except a deliberate one.
 *
 * Its text is deliberately **not** in `src/shared/text`. The catalogue is for
 * what a client reads, and no client ever reads this: it exists for whoever is
 * being shown the demonstration, and it must survive the day the fixtures are
 * deleted along with everything else in this file.
 */
export function DemoDataMarker() {
  if (!FIXTURE_DATA_ENABLED) return null;

  return (
    <div
      data-demo-marker="true"
      role="note"
      className="bg-attention-tint text-attention border-attention sticky top-0 z-50 border-b px-4 py-1.5 text-center text-xs font-medium"
    >
      Datos de demostración. Nada de lo que se ve aquí es real ni pertenece a ninguna persona.
    </div>
  );
}
